module.exports = "<div class=\"box box-2\" ng-if=::vm.text> <div class=box-hd fb-folder init-open=md-up> <h4>{{vm.title}}</h4> </div> <div class=box-bd> <div class=richtext-medipim> <span ng-bind-html=::vm.text></span> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./features/product/components/product-info-box.html
// module id = 630
// module chunks = 0